<h1 miqTitle="" class="brand">{{ appName | uppercase }}</h1>
<h2>{{ 'shared.oops' | xTranslate }}</h2>
<div class="error-container">
  <div class="error-title">
    <div class="error-icon"><mat-icon svgIcon="close-icon-white"></mat-icon></div>
    <h3>{{ errorCode }} {{ 'shared.error' | xTranslate }}</h3>
  </div>
  <p>{{ message }}</p>
  <button mat-button color="primary" class="fx--mr-sm" [routerLink]="['/records']">
    {{ 'shared.goHome' | xTranslate }}
  </button>
  <button mat-flat-button color="primary" (click)="location.back()">{{ 'shared.goBack' | xTranslate }}</button>
</div>
